import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl } from '@ngneat/reactive-forms';
import { Realisation } from '../../classes/realisation';
import { User } from '../../classes/user.class';
import { CodaltComponent } from '../../codalt.component';
import { AuthorisationService } from '../../services/auth/authorisation.service';
import { Functionalities } from '../../services/auth/functionalities';
import { RealisationService } from '../../services/realisation.service';
import { UserService } from '../../services/user/user.service';

@Component({
    selector: 'app-move-realisations-to-performer-dialog',
    standalone: false,
    templateUrl: './move-realisations-to-performer-dialog.component.html',
    styleUrl: './move-realisations-to-performer-dialog.component.scss',
})
export class MoveRealisationsToPerformerDialogComponent extends CodaltComponent {
    fcPerformerSearch = new FormControl<string>();

    private isExecutor = (user: User) => AuthorisationService.hasAnyRole(this.environment.executors, user);

    executors$ = this.userService.getByFunctionality(
        [Functionalities.HourCheck, Functionalities.HourCheckRestricted],
        user => `${this.isExecutor(user) ? 0 : 1}${user.name}`
    );

    saving = false;

    constructor(
        public dialogRef: MatDialogRef<MoveRealisationsToPerformerDialogComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            realisations: Realisation[];
        },
        private realisationService: RealisationService,
        private userService: UserService
    ) {
        super();
    }

    setExecutor(executor: User) {
        if (!this.saving) {
            this.saving = true;
            this.subscriptions.add(
                this.realisationService
                    .moveRealisationsToPerformer(
                        this.data.realisations.map(r => r.id),
                        executor.id
                    )
                    .subscribe(() => {
                        this.dialogRef.close(true);
                    })
            );
        }
    }
}
